import '../scss/layout.scss';
import QADdark from '../assets/logo-qad-white.png';
import { Divider } from 'antd';
import { FacebookFilled, LinkedinFilled, GlobalOutlined } from '@ant-design/icons';

export const Footer = () =>{
    return(
        <div className='footer'>
            <div className='content'>
                <div className='left'>
                    <div className='contacts' style={{width:"165px"}}>
                        <h5>QADworks - USA</h5>
                        <p>1980 Post Oak Blvd #200, Houston, TX 77056<br/>+1-877-QAD-WRKS</p>
                    </div>
                    <div className='contacts'>
                        <h5>QADworks - Philippines</h5>
                        <p>Level 6 Ayala Triangle Gardens Tower 2, Paseo de Roxas cor. Makati Ave.,<br/>Makati City, Metro Manila 1226<br/>+63-2-8-539-2521</p>
                    </div>
                </div>
                <div className='right'>
                    <GlobalOutlined className='icon-btn' onClick={()=>window.open('https://www.qad.works', '_blank').focus()}/>
                    <LinkedinFilled className='icon-btn' onClick={()=>window.open('https://www.linkedin.com/company/qadworks', '_blank').focus()}/>
                    <FacebookFilled  className='icon-btn' onClick={()=>window.open('https://www.facebook.com/QADworksHQ/', '_blank').focus()}/>
                    <Divider type='vertical'/>
                    <img src={QADdark}  onClick={()=>window.open('https://www.qad.works', '_blank').focus()} style={{cursor:'pointer'}} alt='QADworks Logo'/>
                </div>
            </div>
            <div className='rights-reserved'>
                <p>© QADworks Technical Solutions, Inc. 2026 — All rights reserved.</p>
            </div>
        </div>
    )
}